(function(){
  if (window.__spLand) return;
  window.__spLand = true;

  var NOSTRI = ['AT','DE','NL','BE','PL'];
  var GIORNI = { AT:'1–2', DE:'3–5', NL:'3–5', BE:'3–5', PL:'3–5' };   
  
  var EUROPA = ['AL','AD','BA','BG','HR','CY','CZ','DK','EE','FI','FR','GR','HU','IS','IE','IT','XK','LV','LI','LT','LU','MT','MD','MC',
                'ME','MK','NO','PT','RO','SM','RS','SK','SI','ES','SE','CH','UA','GB','VA','GI','FO','GG','JE','IM','AX'];
  var SOLO_MAIL = ['AU'];
  var RICORDA = 'splendido:land-panel';
  var RICORDA_W = 'splendido:land-wait';
  var TRENTA_GIORNI = 30 * 24 * 60 * 60 * 1000;
  var GIORNO = TRENTA_GIORNI / 30, SEI_MESI = 180 * GIORNO, UN_ANNO = 365 * GIORNO;

  
  var DIZ = {
    de: { titolo:'Sind Sie in {L}?', titoloV2:'Lieferung {N}?', intro:'Dann zeigen wir Ihnen Lieferzeiten und Versandoptionen für {L}.',
          b1:'Lieferung in {G} Werktagen', b2:'Versand und Rücksendung kostenlos', b3:'30 Tage Rückgaberecht',
          labPaese:'Lieferland', labLingua:'Sprache', ok:'Nach {L} wechseln', okV2:'Ja, {N} liefern', resta:'Nein, ich bleibe bei {A}', chiudi:'Schließen',
          paesi:{AT:'Österreich', DE:'Deutschland', NL:'Niederlande', BE:'Belgien', PL:'Polen'},
          nach:{AT:'nach Österreich', DE:'nach Deutschland', NL:'in die Niederlande', BE:'nach Belgien', PL:'nach Polen'} },
    en: { titolo:'Are you in {L}?', titoloV2:'Delivery {N}?', intro:'Then we will show you delivery times and shipping options for {L}.',
          b1:'Delivery in {G} working days', b2:'Free shipping and free returns', b3:'30-day right of return',
          labPaese:'Delivery country', labLingua:'Language', ok:'Switch to {L}', okV2:'Yes, deliver {N}', resta:'No, I will stay with {A}', chiudi:'Close',
          paesi:{AT:'Austria', DE:'Germany', NL:'Netherlands', BE:'Belgium', PL:'Poland'},
          nach:{AT:'to Austria', DE:'to Germany', NL:'to the Netherlands', BE:'to Belgium', PL:'to Poland'} },
    nl: { titolo:'Bent u in {L}?', titoloV2:'Levering {N}?', intro:'Dan tonen wij u levertijden en verzendopties voor {L}.',
          b1:'Levering in {G} werkdagen', b2:'Verzending en retour gratis', b3:'30 dagen retourrecht',
          labPaese:'Land van levering', labLingua:'Taal', ok:'Naar {L} wisselen', okV2:'Ja, {N} leveren', resta:'Nee, ik blijf bij {A}', chiudi:'Sluiten',
          paesi:{AT:'Oostenrijk', DE:'Duitsland', NL:'Nederland', BE:'België', PL:'Polen'},
          nach:{AT:'naar Oostenrijk', DE:'naar Duitsland', NL:'naar Nederland', BE:'naar België', PL:'naar Polen'} },
    fr: { titolo:'Êtes-vous en {L} ?', titoloV2:'Livraison {N} ?', intro:'Nous vous montrerons alors les délais et les options de livraison pour {L}.',
          b1:'Livraison en {G} jours ouvrés', b2:'Livraison et retour gratuits', b3:'30 jours pour changer d’avis',
          labPaese:'Pays de livraison', labLingua:'Langue', ok:'Passer à {L}', okV2:'Oui, livrer {N}', resta:'Non, je reste sur {A}', restaV2:'Non, je reste {B}', chiudi:'Fermer',
          paesi:{AT:'Autriche', DE:'Allemagne', NL:'Pays-Bas', BE:'Belgique', PL:'Pologne'},
          nach:{AT:'en Autriche', DE:'en Allemagne', NL:'aux Pays-Bas', BE:'en Belgique', PL:'en Pologne'},
          'in':{AT:'en Autriche', DE:'en Allemagne', NL:'aux Pays-Bas', BE:'en Belgique', PL:'en Pologne'} },
    es: { titolo:'¿Está usted en {L}?', titoloV2:'¿Entrega {N}?', intro:'Le mostraremos los plazos y las opciones de envío para {L}.',
          b1:'Entrega en {G} días laborables', b2:'Envío y devolución gratuitos', b3:'30 días para devolver',
          labPaese:'País de entrega', labLingua:'Idioma', ok:'Cambiar a {L}', okV2:'Sí, entregar {N}', resta:'No, me quedo en {A}', restaV2:'No, me quedo {B}', chiudi:'Cerrar',
          paesi:{AT:'Austria', DE:'Alemania', NL:'Países Bajos', BE:'Bélgica', PL:'Polonia'},
          nach:{AT:'a Austria', DE:'a Alemania', NL:'a los Países Bajos', BE:'a Bélgica', PL:'a Polonia'},
          'in':{AT:'en Austria', DE:'en Alemania', NL:'en los Países Bajos', BE:'en Bélgica', PL:'en Polonia'} },
    pl: { titolo:'Czy jest Pan/Pani w {L}?', titoloV2:'Dostawa {N}?', intro:'Pokażemy wtedy czas i opcje dostawy dla {L}.',
          b1:'Dostawa w {G} dni roboczych', b2:'Wysyłka i zwrot bezpłatne', b3:'30 dni na zwrot',
          labPaese:'Kraj dostawy', labLingua:'Język', ok:'Przejdź do {L}', okV2:'Tak, dostawa {N}', resta:'Nie, zostaję przy {A}', restaV2:'Nie, zostaję {B}', chiudi:'Zamknij',
          paesi:{AT:'Austria', DE:'Niemcy', NL:'Holandia', BE:'Belgia', PL:'Polska'},
          nach:{AT:'do Austrii', DE:'do Niemiec', NL:'do Holandii', BE:'do Belgii', PL:'do Polski'},
          'in':{AT:'w Austrii', DE:'w Niemczech', NL:'w Holandii', BE:'w Belgii', PL:'w Polsce'} }
  };

  
  var KLAVIYO_COMPANY = 'SaEb9w';   
  var KLAVIYO_LISTA   = 'WazUKp';   

  var DIZW = {
    de: { titolo:'{L}: noch kein Versandland.',
          introPaesi:'Wir liefern derzeit nur in diese Länder:',
          intro:'Wir versenden derzeit nach Österreich, Deutschland, in die Niederlande, nach Belgien und Polen.',
          intro2:'Haben Sie eine Lieferadresse in einem dieser Länder? Dann können Sie ganz normal bestellen.',
          avvisa:'Bescheid geben, sobald wir liefern',
          labNome:'Vorname', labMail:'E-Mail-Adresse', ok:'Auf die Warteliste',
          nota:'Unverbindlich. Wir verwenden Ihre Angaben ausschließlich, um Sie einmalig zu benachrichtigen, sobald wir in Ihr Land ({L}) liefern. Sie erhalten von uns keinen Newsletter und keine weiteren Werbe-E-Mails. Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) über unseren Dienstleister Klaviyo. Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen — über den Abmeldelink in jeder E-Mail oder formlos an info@splendido.at. Wenn wir bis dahin nicht in Ihr Land liefern, löschen wir Ihre Daten spätestens nach 24 Monaten. Weitere Informationen in unserer [LINK].',
          limiti:'Der Rabatt gilt für Ihre erste Bestellung, einmal pro Person einlösbar und nicht mit anderen Aktionen oder Gutscheinen kombinierbar.',
          promoForte:'10 % auf Ihre erste Bestellung', promoTenue:'sobald wir in Ihr Land liefern.', dettagli:'Wie wir Ihre Daten verwenden',
          privacy:'Datenschutzerklärung', resta:'Nur stöbern', chiudi:'Schließen',
          errNome:'Bitte geben Sie Ihren Vornamen an.', errMail:'Bitte geben Sie eine gültige E-Mail-Adresse an.',
          errRete:'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          grazieT:'Fast geschafft.',
          grazieP:'Wir haben Ihnen eine E-Mail geschickt. Bitte bestätigen Sie darin Ihre Anmeldung — erst dann stehen Sie auf der Warteliste.',
          grazieOk:'Schließen',
          paesi:{AT:'Österreich', DE:'Deutschland', NL:'Niederlande', BE:'Belgien', PL:'Polen'} },
    
    en: { titolo:'We do not ship to {L} yet.',
          introPaesi:'We currently deliver only to these countries:',
          intro:'We currently ship to Austria, Germany, the Netherlands, Belgium and Poland.',
          intro2:'Do you have a delivery address in one of these countries? Then you can order as usual.',
          avvisa:'Let me know when you deliver',
          labNome:'First name', labMail:'Email address', ok:'Join the waiting list',
          nota:'No obligation. We use your details solely to notify you once, as soon as we deliver to your country ({L}). You will not receive a newsletter or any further marketing emails from us. Processing is based on your consent (Art. 6(1)(a) GDPR) via our service provider Klaviyo. You can withdraw your consent at any time with effect for the future — via the unsubscribe link in every email or informally at info@splendido.at. If we do not deliver to your country by then, we will delete your data after 24 months at the latest. Further information in our [LINK].',
          limiti:'The discount applies to your first order, can be redeemed once per person and cannot be combined with other promotions or vouchers.',
          promoForte:'10 % off your first order', promoTenue:'as soon as we ship to your country.', dettagli:'How we use your data',
          privacy:'privacy policy', resta:'Just browsing', chiudi:'Close',
          errNome:'Please enter your first name.', errMail:'Please enter a valid email address.',
          errRete:'Something went wrong. Please try again.',
          grazieT:'Almost done.',
          grazieP:'We have sent you an email. Please confirm your registration there — only then will you be on the waiting list.',
          grazieOk:'Close',
          paesi:{AT:'Austria', DE:'Germany', NL:'Netherlands', BE:'Belgium', PL:'Poland'} },
    nl: { titolo:'{L}: nog geen bezorgland.',
          introPaesi:'Wij leveren momenteel alleen in deze landen:',
          intro:'Wij verzenden momenteel naar Oostenrijk, Duitsland, Nederland, België en Polen.',
          intro2:'Heeft u een bezorgadres in een van deze landen? Dan kunt u gewoon bestellen.',
          avvisa:'Bericht geven zodra u levert',
          labNome:'Voornaam', labMail:'E-mailadres', ok:'Op de wachtlijst',
          nota:'Vrijblijvend. Wij gebruiken uw gegevens uitsluitend om u éénmalig te informeren zodra wij in uw land ({L}) leveren. U ontvangt van ons geen nieuwsbrief en geen verdere reclame-e-mails. De verwerking gebeurt op basis van uw toestemming (art. 6 lid 1 sub a AVG) via onze dienstverlener Klaviyo. U kunt uw toestemming te allen tijde met werking voor de toekomst intrekken — via de afmeldlink in elke e-mail of informeel via info@splendido.at. Als wij tegen die tijd niet in uw land leveren, verwijderen wij uw gegevens uiterlijk na 24 maanden. Meer informatie in onze [LINK].',
          limiti:'De korting geldt voor uw eerste bestelling, is éénmaal per persoon inwisselbaar en niet combineerbaar met andere acties of kortingsbonnen.',
          promoForte:'10 % op uw eerste bestelling', promoTenue:'zodra wij in uw land leveren.', dettagli:'Hoe wij uw gegevens gebruiken',
          privacy:'privacyverklaring', resta:'Alleen rondkijken', chiudi:'Sluiten',
          errNome:'Vul uw voornaam in.', errMail:'Vul een geldig e-mailadres in.',
          errRete:'Er is een fout opgetreden. Probeer het opnieuw.',
          grazieT:'Bijna klaar.',
          grazieP:'Wij hebben u een e-mail gestuurd. Bevestig daarin uw aanmelding — pas dan staat u op de wachtlijst.',
          grazieOk:'Sluiten',
          paesi:{AT:'Oostenrijk', DE:'Duitsland', NL:'Nederland', BE:'België', PL:'Polen'} },
    fr: { titolo:'{L} : pas encore de livraison.',
          introPaesi:'Nous livrons actuellement uniquement dans ces pays :',
          intro:'Nous livrons actuellement en Autriche, en Allemagne, aux Pays-Bas, en Belgique et en Pologne.',
          intro2:'Vous avez une adresse de livraison dans l’un de ces pays ? Alors vous pouvez commander normalement.',
          avvisa:'Me prévenir dès que vous livrez',
          labNome:'Prénom', labMail:'Adresse e-mail', ok:'Rejoindre la liste d’attente',
          nota:'Sans engagement. Nous utilisons vos données uniquement pour vous informer une seule fois, dès que nous livrerons dans votre pays ({L}). Vous ne recevrez de notre part ni newsletter ni autre e-mail publicitaire. Le traitement repose sur votre consentement (art. 6 § 1 lit. a RGPD) via notre prestataire Klaviyo. Vous pouvez retirer votre consentement à tout moment avec effet pour l’avenir — via le lien de désinscription présent dans chaque e-mail ou par simple message à info@splendido.at. Si nous ne livrons pas dans votre pays d’ici là, nous supprimerons vos données au plus tard après 24 mois. Plus d’informations dans notre [LINK].',
          limiti:'La remise s’applique à votre première commande, est utilisable une fois par personne et n’est pas cumulable avec d’autres offres ou bons.',
          promoForte:'10 % sur votre première commande', promoTenue:'dès que nous livrerons dans votre pays.', dettagli:'Comment nous utilisons vos données',
          privacy:'politique de confidentialité', resta:'Je regarde seulement', chiudi:'Fermer',
          errNome:'Veuillez indiquer votre prénom.', errMail:'Veuillez indiquer une adresse e-mail valide.',
          errRete:'Une erreur est survenue. Veuillez réessayer.',
          grazieT:'Presque terminé.',
          grazieP:'Nous vous avons envoyé un e-mail. Veuillez y confirmer votre inscription — vous ne serez sur la liste d’attente qu’ensuite.',
          grazieOk:'Fermer',
          paesi:{AT:'Autriche', DE:'Allemagne', NL:'Pays-Bas', BE:'Belgique', PL:'Pologne'} },
    es: { titolo:'{L}: todavía sin envíos.',
          introPaesi:'Actualmente solo enviamos a estos países:',
          intro:'Actualmente enviamos a Austria, Alemania, los Países Bajos, Bélgica y Polonia.',
          intro2:'¿Tiene una dirección de entrega en uno de estos países? Entonces puede pedir con normalidad.',
          avvisa:'Avisarme cuando envíen',
          labNome:'Nombre', labMail:'Correo electrónico', ok:'Apuntarme a la lista de espera',
          nota:'Sin compromiso. Utilizamos sus datos únicamente para avisarle una sola vez en cuanto enviemos a su país ({L}). No recibirá de nosotros ningún boletín ni otros correos publicitarios. El tratamiento se basa en su consentimiento (art. 6, apdo. 1, letra a del RGPD) a través de nuestro proveedor Klaviyo. Puede revocar su consentimiento en cualquier momento con efecto para el futuro — mediante el enlace de baja en cada correo o de manera informal en info@splendido.at. Si para entonces no enviamos a su país, eliminaremos sus datos a más tardar a los 24 meses. Más información en nuestra [LINK].',
          limiti:'El descuento es válido para su primer pedido, canjeable una vez por persona y no acumulable con otras promociones o vales.',
          promoForte:'10 % en su primer pedido', promoTenue:'en cuanto enviemos a su país.', dettagli:'Cómo utilizamos sus datos',
          privacy:'política de privacidad', resta:'Solo estoy mirando', chiudi:'Cerrar',
          errNome:'Indique su nombre.', errMail:'Indique una dirección de correo electrónico válida.',
          errRete:'Se ha producido un error. Inténtelo de nuevo.',
          grazieT:'Casi listo.',
          grazieP:'Le hemos enviado un correo electrónico. Confirme en él su inscripción — solo entonces estará en la lista de espera.',
          grazieOk:'Cerrar',
          paesi:{AT:'Austria', DE:'Alemania', NL:'Países Bajos', BE:'Bélgica', PL:'Polonia'} },
    pl: { titolo:'{L}: jeszcze nie wysyłamy.',
          introPaesi:'Obecnie dostarczamy tylko do tych krajów:',
          intro:'Obecnie wysyłamy do Austrii, Niemiec, Holandii, Belgii i Polski.',
          intro2:'Czy ma Pan/Pani adres dostawy w jednym z tych krajów? W takim razie można zamawiać normalnie.',
          avvisa:'Powiadomcie mnie, gdy zaczniecie dostarczać',
          labNome:'Imię', labMail:'Adres e-mail', ok:'Zapisać się na listę oczekujących',
          nota:'Bez zobowiązań. Wykorzystujemy Państwa dane wyłącznie po to, aby jednorazowo powiadomić, gdy zaczniemy dostarczać do Państwa kraju ({L}). Nie otrzymają Państwo od nas newslettera ani innych e-maili reklamowych. Przetwarzanie odbywa się na podstawie Państwa zgody (art. 6 ust. 1 lit. a RODO) za pośrednictwem naszego usługodawcy Klaviyo. Zgodę można w każdej chwili wycofać ze skutkiem na przyszłość — przez link rezygnacji w każdym e-mailu lub nieformalnie na info@splendido.at. Jeśli do tego czasu nie będziemy dostarczać do Państwa kraju, usuniemy dane najpóźniej po 24 miesiącach. Więcej informacji w naszej [LINK].',
          limiti:'Rabat dotyczy pierwszego zamówienia, można go wykorzystać raz na osobę i nie łączy się z innymi promocjami ani bonami.',
          promoForte:'10 % na pierwsze zamówienie', promoTenue:'gdy zaczniemy wysyłać do Państwa kraju.', dettagli:'Jak wykorzystujemy Państwa dane',
          privacy:'polityce prywatności', resta:'Tylko oglądam', chiudi:'Zamknij',
          errNome:'Proszę podać imię.', errMail:'Proszę podać prawidłowy adres e-mail.',
          errRete:'Wystąpił błąd. Proszę spróbować ponownie.',
          grazieT:'Prawie gotowe.',
          grazieP:'Wysłaliśmy do Państwa e-mail. Proszę potwierdzić w nim zapis — dopiero wtedy znajdą się Państwo na liście oczekujących.',
          grazieOk:'Zamknij',
          paesi:{AT:'Austria', DE:'Niemcy', NL:'Holandia', BE:'Belgia', PL:'Polska'} }
  };

  var ALIAS = { 'be':'nl', 'fy':'nl', 'af':'nl', 'ca':'es', 'gl':'es', 'eu':'es', 'oc':'fr', 'br':'fr', 'co':'fr', 'lb':'de', 'gsw':'de' };
  var PER_PAESE = { DE:'de', AT:'de', CH:'de', LI:'de', NL:'nl', BE:'en', PL:'pl' };

  var root = document.getElementById('sp-land');
  var wroot = document.getElementById('sp-wait');
  if (!root) return;
  var paeseOra = (root.getAttribute('data-paese-ora') || '').toUpperCase();
  var linguaPagina = (root.getAttribute('data-lingua-ora') || 'de').toLowerCase();
  var pagina = root.getAttribute('data-pagina') || '';
  var bandiereBase = root.getAttribute('data-bandiere') || '';
  var T0 = Date.now();

  
  var PACCO = ('bg,bs,ca,cs,da,el,et,fi,ga,hr,hu,is,it,lt,lv,mk,mt,no,pt,ro,ru,sk,sl,sq,sr,sv,tr,uk').split(',');
  function conosciamo(l){ return !!DIZ[l] || PACCO.indexOf(l) !== -1; }

  
  function misura(nome, dati){
    var d = dati || {};
    try { if (typeof window.clarity === 'function'){ window.clarity('event', nome); window.clarity('set', 'sp_land', nome + (d.paese ? ':' + d.paese : '')); } } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nome }, d)); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(nome, d); } catch (e) {}
  }

  
  var paccoStato = 0;
  var paccoCoda = [];
  function caricaPacco(poi){
    if (paccoStato === 2) return poi();
    paccoCoda.push(poi);
    if (paccoStato === 1) return;
    paccoStato = 1;
    function finito(){
      if (paccoStato === 2) return;
      paccoStato = 2;
      var p = window.__spLandLingue;
      if (p){
        for (var k in p.diz)  if (!DIZ[k])  DIZ[k]  = p.diz[k];
        for (var k2 in p.dizw) if (!DIZW[k2]) DIZW[k2] = p.dizw[k2];
      }
      for (var i = 0; i < paccoCoda.length; i++) paccoCoda[i]();
      paccoCoda = [];
    }
    var url = root.getAttribute('data-pacco');
    if (!url) return finito();
    var sc = document.createElement('script');
    sc.src = url; sc.async = true;
    sc.onload = finito; sc.onerror = finito;
    document.head.appendChild(sc);
    setTimeout(finito, 5000);   
  }
  function conLingua(l, poi){
    if (DIZ[l]) return poi();
    caricaPacco(poi);
  }

  var linguaProva = '';
  try { linguaProva = (new URLSearchParams(window.location.search).get('sp-land-lingua') || '').toLowerCase().substring(0,2); } catch (e) {}

  
  function lingua(paese){
    if (linguaProva && conosciamo(linguaProva)) return linguaProva;
    var b = (navigator.language || navigator.userLanguage || '').substring(0,2).toLowerCase();
    b = ALIAS[b] || b;
    if (conosciamo(b)) return b;
    if (conosciamo(linguaPagina) && linguaPagina !== 'de') return linguaPagina;
    if (paese && PER_PAESE[paese] && DIZ[PER_PAESE[paese]]) return PER_PAESE[paese];
    return 'en';
  }

  
  function nomePaese(iso, lang, ripiego){
    try {
      if (window.Intl && Intl.DisplayNames){
        var n = new Intl.DisplayNames([lang], { type:'region' }).of(iso);
        if (n && n !== iso) return n;
      }
    } catch (e) {}
    return ripiego || iso;
  }
  function nomeP(T, iso, lang){ return (T.paesi && T.paesi[iso]) || nomePaese(iso, lang, iso); }

  
  function bandiera(img, iso){
    if (!img) return;
    img.hidden = true;
    if (!bandiereBase || !iso) return;
    var src = bandiereBase.replace(/sp-flag-at\.svg/, 'sp-flag-' + String(iso).toLowerCase() + '.svg');
    img.onload = function(){ img.hidden = false; };
    img.onerror = function(){ img.hidden = true; };
    img.src = src;
  }

  
  function leggiMem(chiave){
    try {
      var v = localStorage.getItem(chiave);
      if (!v) return null;
      var m = /^(\d+):(\d+)$/.exec(v);
      if (m) return { n: parseInt(m[1], 10), t: parseInt(m[2], 10) };
      var t = parseInt(v, 10);            
      return isNaN(t) ? null : { n: 1, t: t };
    } catch (e) { return null; }
  }
  function giaDeciso(){
    var m = leggiMem(RICORDA);
    if (!m) return false;
    return (Date.now() - m.t) < (m.n >= 2 ? SEI_MESI : TRENTA_GIORNI);
  }
  function segnaDeciso(forte){
    var m = leggiMem(RICORDA);
    var n = forte ? 2 : ((m ? m.n : 0) + 1);
    try { localStorage.setItem(RICORDA, n + ':' + Date.now()); } catch (e) {}
  }

  
  function consensoDato(){ return document.cookie.indexOf('_pandectes_gdpr') !== -1; }
  function aspettaConsenso(poi){
    if (consensoDato()) return poi();
    var fatto = false;
    function via(){ if (fatto) return; fatto = true; poi(); }
    var eventi = ['PandectesConsentUpdate', 'PandectesConsentUpdateLegacy', 'PandectesDialogClosed', 'PandectesButtonClicked'];
    for (var i = 0; i < eventi.length; i++){ document.addEventListener(eventi[i], via); window.addEventListener(eventi[i], via); }
    var giri = 0;
    (function guarda(){
      if (fatto) return;
      if (consensoDato()) return via();
      if (++giri > 90) return;               
      setTimeout(guarda, 1000);
    })();
  }

  
  var pagineViste = 1;
  try {
    pagineViste = (parseInt(sessionStorage.getItem('splendido:pv') || '0', 10) || 0) + 1;
    sessionStorage.setItem('splendido:pv', String(pagineViste));
  } catch (e) {}

  function quotaScroll(){
    var h = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    return (window.pageYOffset || document.documentElement.scrollTop || 0) / h;
  }
  
  function interesseLand(poi){
    if (['collection', 'product', 'cart'].indexOf(pagina) === -1) return;
    var fatto = false;
    function via(){ if (fatto) return; fatto = true; window.removeEventListener('scroll', via); poi(); }
    window.addEventListener('scroll', via, { passive:true });
    setTimeout(via, 4000);
  }
  
  function interesseWait(poi){
    var fatto = false;
    function via(){
      if (fatto) return;
      var resto = 10000 - (Date.now() - T0);
      if (resto > 0) return setTimeout(via, resto);
      fatto = true;
      window.removeEventListener('scroll', suScroll);
      document.removeEventListener('click', suClick, true);
      document.removeEventListener('submit', suSubmit, true);
      poi();
    }
    function suScroll(){ if (pagina === 'product' && quotaScroll() >= 0.3) via(); }
    function suClick(e){
      var t = e.target && e.target.closest ? e.target.closest('button[name="add"], [data-sp-atc], form[action*="/cart/add"] [type="submit"]') : null;
      if (t) via();
    }
    function suSubmit(e){ if (e.target && /\/cart\/add/.test(e.target.getAttribute('action') || '')) via(); }
    if (pagineViste >= 2) return via();
    window.addEventListener('scroll', suScroll, { passive:true });
    document.addEventListener('click', suClick, true);
    document.addEventListener('submit', suSubmit, true);
  }

  
  function prova(){
    var v = '';
    try { v = (new URLSearchParams(window.location.search).get('sp-land') || '').toUpperCase(); } catch (e) {}
    if (v === 'RESET'){ try { localStorage.removeItem(RICORDA); localStorage.removeItem(RICORDA_W); sessionStorage.removeItem('splendido:pv'); } catch (e) {} return null; }
    if (v === 'DEBUG') return 'DEBUG';
    return /^[A-Z]{2}$/.test(v) ? v : null;
  }

  function tipoWait(iso){
    if (EUROPA.indexOf(iso) !== -1) return 'europa';
    if (SOLO_MAIL.indexOf(iso) !== -1) return 'mail';
    return null;
  }

  function diagnosi(){
    var box = document.createElement('div');
    box.style.cssText = 'position:fixed;left:10px;right:10px;top:10px;z-index:2147483001;background:#1c1c1c;' +
      'color:#f3efe9;font:13px/1.6 monospace;padding:14px 16px;border-radius:6px;max-width:560px;margin:0 auto;' +
      'box-shadow:0 8px 30px rgba(0,0,0,.4);white-space:pre-wrap';
    function scrivi(righe){ box.textContent = righe.join('\n'); }
    scrivi(['SPLENDIDO — diagnosi finestra paese v2', 'sto chiedendo a Shopify da dove arrivi…']);
    document.body.appendChild(box);
    rileva(function(rilevato, nomeShopify){
      var perche, tipo = rilevato ? tipoWait(rilevato) : null;
      if (!rilevato) perche = 'NON esce: Shopify non mi dice il paese';
      else if (NOSTRI.indexOf(rilevato) === -1){
        if (!tipo) perche = 'NON esce: ' + rilevato + ' e fuori Europa (e non e Australia) → niente, per scelta';
        else if (waitDeciso()) perche = 'NON esce la LISTA D ATTESA: gia chiusa o gia iscritto (?sp-land=reset per azzerare)';
        else if (!consensoDato()) perche = 'aspetta il banner dei cookie, poi la LISTA D ATTESA (' + tipo + ') dopo un segno d interesse';
        else perche = 'LISTA D ATTESA (' + tipo + ') dopo: 10 s + (2ª pagina | 30% scroll su prodotto | clic In den Warenkorb). Pagine viste: ' + pagineViste;
      }
      else if (rilevato === paeseOra) perche = 'NON esce: sei gia sul paese giusto';
      else if (giaDeciso()) perche = 'NON esce: hai gia scelto o chiuso (usa ?sp-land=reset per azzerare)';
      else if (['collection','product','cart'].indexOf(pagina) === -1) perche = 'NON esce su questa pagina (' + (pagina || '?') + '): la finestra 1 esce solo su collezione, prodotto, carrello';
      else if (!consensoDato()) perche = 'aspetta: devi ancora cliccare sul banner dei cookie';
      else perche = 'FINESTRA 1 al primo scroll o dopo 4 s: rilevato ' + rilevato + ', servito ' + paeseOra;
      var m = leggiMem(RICORDA);
      scrivi([
        'SPLENDIDO — diagnosi finestra paese v2', '',
        'pagina                     : ' + (pagina || '?') + '   (pagine viste in sessione: ' + pagineViste + ')',
        'paese servito dalla pagina : ' + paeseOra,
        'paese rilevato da Shopify  : ' + (rilevato || '(nessuno)') + (rilevato ? '   → ' + (NOSTRI.indexOf(rilevato) !== -1 ? 'nostro' : (tipo || 'fuori Europa')) : ''),
        'nome del paese in finestra : ' + (rilevato ? nomePaese(rilevato, lingua(rilevato), nomeShopify) : '-'),
        'lingua del browser         : ' + (navigator.language || '?') + '   → finestra in: ' + lingua(rilevato),
        'consenso cookie gia dato   : ' + (consensoDato() ? 'si' : 'NO'),
        'finestra 1                 : ' + (m ? ('chiusa/scelta ' + m.n + 'x, ' + Math.round((Date.now() - m.t) / GIORNO) + ' giorni fa') : 'mai vista'),
        'lista d attesa             : ' + (function(){ var v = null; try { v = localStorage.getItem(RICORDA_W); } catch (e) {} return v ? (String(v).indexOf('ok:') === 0 ? 'gia iscritto' : 'chiusa') : 'mai vista'; })(),
        '', perche
      ]);
    });
  }

  function rileva(poi){
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'browsing_context_suggestions.json'
            : '/browsing_context_suggestions.json', { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        var d = j && j.detected_values;
        var c = d && d.country && d.country.handle;
        var n = (d && d.country && d.country.name) || (d && d.country_name) || '';
        poi(c ? String(c).toUpperCase() : null, n);
      })
      .catch(function(){ poi(null, ''); });
  }

  
  function entra(el){
    el.hidden = false;
    
    document.documentElement.classList.add('sp-land-open');
    el.classList.remove('is-in');
    void el.offsetWidth;
    
    function via(){ el.classList.add('is-in'); }
    requestAnimationFrame(via);
    setTimeout(via, 60);
  }
  function esci(el, poi){
    el.classList.remove('is-in');
    setTimeout(function(){
      el.hidden = true;
      if (!document.querySelector('.sp-land:not([hidden])')) document.documentElement.classList.remove('sp-land-open');
      if (poi) poi();
    }, 450);
  }

  
  var landLang = 'de', landIso = '';
  function testoTitolo(T, iso, lang){
    if (T.titoloV2 && T.nach && T.nach[iso]) return T.titoloV2.replace('{N}', T.nach[iso]);
    return T.titolo.replace('{L}', nomeP(T, iso, lang));
  }
  function testoOk(T, iso, lang){
    if (T.okV2 && T.nach && T.nach[iso]) return T.okV2.replace('{N}', T.nach[iso]);
    return T.ok.replace('{L}', nomeP(T, iso, lang));
  }
  
  function testoResta(T, iso, lang){
    if (T.restaV2 && T['in'] && T['in'][iso]) return T.restaV2.replace('{B}', T['in'][iso]);
    return T.resta.replace('{A}', nomeP(T, iso, lang));
  }
  function mostra(rilevato){
    landLang = lingua(rilevato);
    landIso = rilevato;
    var T = DIZ[landLang] || DIZ.en;
    var nomeOra = nomeP(T, paeseOra, landLang);

    document.getElementById('sp-land-titolo').textContent = testoTitolo(T, rilevato, landLang);
    bandiera(document.getElementById('sp-land-flag'), rilevato);
    var lista = document.getElementById('sp-land-lista');
    lista.innerHTML = '';
    [T.b1.replace('{G}', GIORNI[rilevato] || '1–5'), T.b2, T.b3].forEach(function(t){
      var li = document.createElement('li'); li.textContent = t; lista.appendChild(li);
    });
    document.getElementById('sp-land-lab-paese').textContent  = T.labPaese;
    document.getElementById('sp-land-lab-lingua').textContent = T.labLingua;
    document.getElementById('sp-land-ok').textContent    = testoOk(T, rilevato, landLang);
    document.getElementById('sp-land-resta').textContent = testoResta(T, paeseOra, landLang);
    document.getElementById('sp-land-x').setAttribute('aria-label', T.chiudi);
    document.getElementById('sp-land-more-btn').setAttribute('aria-label', T.labLingua + ' · ' + T.labPaese);

    var tasti = root.querySelectorAll('[data-sp-land-paese]');
    for (var i = 0; i < tasti.length; i++){
      var iso = tasti[i].getAttribute('data-sp-land-paese');
      tasti[i].querySelector('[data-nome]').textContent = nomeP(T, iso, landLang);
      tasti[i].classList.toggle('is-on', iso === rilevato);
    }
    document.getElementById('sp-land-country').value = rilevato;
    document.getElementById('sp-land-more').hidden = true;
    document.getElementById('sp-land-more-btn').setAttribute('aria-expanded', 'false');

    entra(root);
    misura('sp_land_shown', { finestra: 1, paese: rilevato, servito: paeseOra, lingua: landLang, pagina: pagina });
  }
  function chiudi(){
    esci(root);
    segnaDeciso(false);
    misura('sp_land_closed', { finestra: 1, paese: landIso, lingua: landLang, pagina: pagina });
  }

  root.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var p = t.closest('[data-sp-land-paese]');
    if (p){
      e.preventDefault();
      var iso = p.getAttribute('data-sp-land-paese');
      var tasti = root.querySelectorAll('[data-sp-land-paese]');
      for (var i = 0; i < tasti.length; i++) tasti[i].classList.remove('is-on');
      p.classList.add('is-on');
      document.getElementById('sp-land-country').value = iso;
      var T = DIZ[landLang] || DIZ.en;   
      document.getElementById('sp-land-ok').textContent = testoOk(T, iso, landLang);
      return;
    }
    if (t.closest('#sp-land-more-btn')){
      e.preventDefault();
      var more = document.getElementById('sp-land-more');
      more.hidden = !more.hidden;
      document.getElementById('sp-land-more-btn').setAttribute('aria-expanded', String(!more.hidden));
      return;
    }
    if (t.closest('[data-sp-land-chiudi]')){ e.preventDefault(); chiudi(); }
  });
  var selLingua = document.getElementById('sp-land-lingua');
  if (selLingua) selLingua.addEventListener('change', function(){
    document.getElementById('sp-land-locale').value = selLingua.value;
    document.getElementById('sp-land-more-txt').textContent = selLingua.options[selLingua.selectedIndex].text;
  });
  var form = document.getElementById('sp-land-form');
  if (form) form.addEventListener('submit', function(){
    segnaDeciso(true);
    misura('sp_land_switched', { finestra: 1, da: paeseOra, a: document.getElementById('sp-land-country').value, lingua: landLang, pagina: pagina });
  });
  document.addEventListener('keydown', function(e){
    if (!root.hidden && (e.key === 'Escape' || e.key === 'Esc')) chiudi();
  });

  
  var waitIso = '', waitLang = 'en', waitNome = '', waitTipo = 'europa';

  function waitDeciso(){
    try {
      var v = localStorage.getItem(RICORDA_W);
      if (!v) return false;
      if (v.indexOf('ok:') === 0) return (Date.now() - parseInt(v.slice(3), 10)) < UN_ANNO;
      return (Date.now() - parseInt(v, 10)) < TRENTA_GIORNI;
    } catch (e) { return false; }
  }
  function segnaWait(iscritto){
    try { localStorage.setItem(RICORDA_W, (iscritto ? 'ok:' : '') + Date.now()); } catch (e) {}
  }

  
  function scriviNota(el, testo, url, parola){
    el.textContent = '';
    var p = testo.split('[LINK]');
    el.appendChild(document.createTextNode(p[0]));
    if (p.length > 1){
      var a = document.createElement('a');
      a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.textContent = parola;
      el.appendChild(a);
      el.appendChild(document.createTextNode(p[1]));
    }
  }

  function mostraWait(iso, nomeShopify, tipo){
    if (!wroot) return;
    waitLang = lingua(iso);
    waitIso = iso;
    waitTipo = tipo || 'europa';
    var T = DIZW[waitLang] || DIZW.en;
    waitNome = nomePaese(iso, waitLang, nomeShopify);

    document.getElementById('sp-wait-titolo').textContent = T.titolo.replace(/\{L\}/g, waitNome);
    bandiera(document.getElementById('sp-wait-flag'), iso);
    
    document.getElementById('sp-wait-paesi-blocco').hidden = (waitTipo === 'mail');
    document.getElementById('sp-wait-intro').textContent  = T.introPaesi || T.intro;
    document.getElementById('sp-wait-intro2').textContent = T.intro2;
    document.getElementById('sp-wait-apri').textContent = T.avvisa || T.ok;
    document.getElementById('sp-wait-promo-forte').textContent = T.promoForte || '';
    document.getElementById('sp-wait-promo-tenue').textContent = T.promoTenue || '';
    document.getElementById('sp-wait-dett-s').textContent = T.dettagli || T.privacy;
    document.getElementById('sp-wait-lab-nome').textContent = T.labNome;
    document.getElementById('sp-wait-lab-mail').textContent = T.labMail;
    document.getElementById('sp-wait-ok').textContent    = T.ok;
    document.getElementById('sp-wait-resta').textContent = T.resta;
    document.getElementById('sp-wait-resta2').textContent = T.resta;
    document.getElementById('sp-wait-x').setAttribute('aria-label', T.chiudi);
    document.getElementById('sp-wait-grazie-t').textContent  = T.grazieT;
    document.getElementById('sp-wait-grazie-p').textContent  = T.grazieP;
    document.getElementById('sp-wait-grazie-ok').textContent = T.grazieOk;
    document.getElementById('sp-wait-limiti').textContent = T.limiti;
    scriviNota(document.getElementById('sp-wait-nota'), T.nota.replace(/\{L\}/g, waitNome),
               wroot.getAttribute('data-privacy') || '/', T.privacy);

    document.getElementById('sp-wait-country').value = paeseOra;
    var etichette = wroot.querySelectorAll('[data-sp-wait-paese]');
    for (var i = 0; i < etichette.length; i++){
      var k = etichette[i].getAttribute('data-sp-wait-paese');
      etichette[i].querySelector('[data-nome]').textContent = nomeP(T, k, waitLang);
    }
    
    document.getElementById('sp-wait-passo1').hidden = false;
    document.getElementById('sp-wait-fold').classList.remove('is-open');
    document.getElementById('sp-wait-modulo').hidden = false;
    document.getElementById('sp-wait-grazie').hidden = true;

    entra(wroot);
    misura('sp_wait_shown', { finestra: 2, tipo: waitTipo, paese: iso, lingua: waitLang, pagina: pagina, pagineViste: pagineViste });
  }
  function apriModulo(){
    document.getElementById('sp-wait-passo1').hidden = true;
    document.getElementById('sp-wait-fold').classList.add('is-open');
    setTimeout(function(){ var n = document.getElementById('sp-wait-nome'); if (n) n.focus({ preventScroll:true }); }, 300);
    misura('sp_wait_open', { finestra: 2, tipo: waitTipo, paese: waitIso, lingua: waitLang });
  }
  function chiudiWait(iscritto){
    if (!wroot) return;
    esci(wroot);
    segnaWait(!!iscritto);
    if (!iscritto) misura('sp_wait_closed', { finestra: 2, tipo: waitTipo, paese: waitIso, lingua: waitLang });
  }

  function iscriviWait(){
    var T = DIZW[waitLang] || DIZW.en;
    var cn = document.getElementById('sp-wait-nome');
    var cm = document.getElementById('sp-wait-mail');
    var err = document.getElementById('sp-wait-err');
    var btn = document.getElementById('sp-wait-ok');
    var nome = (cn.value || '').trim();
    var mail = (cm.value || '').trim();

    cn.classList.remove('is-err'); cm.classList.remove('is-err'); err.hidden = true;
    if (!nome){ cn.classList.add('is-err'); err.textContent = T.errNome; err.hidden = false; cn.focus(); return; }
    if (!mail || !cm.checkValidity()){ cm.classList.add('is-err'); err.textContent = T.errMail; err.hidden = false; cm.focus(); return; }

    var props = {
      WaitlistCountry: waitIso,
      WaitlistCountryName: waitNome,
      WaitlistCountryServed: 'no',
      WaitlistVariant: waitTipo,
      Locale: waitLang,
      SourcePage: window.location.href
    };

    btn.disabled = true;
    var fatto = false;
    function ok(){
      if (fatto) return; fatto = true;
      document.getElementById('sp-wait-modulo').hidden = true;
      document.getElementById('sp-wait-grazie').hidden = false;
      segnaWait(true);
      misura('sp_wait_signup', { finestra: 2, tipo: waitTipo, paese: waitIso, lingua: waitLang });
    }
    function ko(){
      if (fatto) return; fatto = true;
      btn.disabled = false;
      err.textContent = T.errRete; err.hidden = false;
    }

    
    var iscrizione = { data: { type:'subscription', attributes: {
      custom_source: 'Länder-Warteliste (Website)',
      profile: { data: { type:'profile', attributes: { email: mail, first_name: nome, properties: props } } }
    }, relationships: { list: { data: { type:'list', id: KLAVIYO_LISTA } } } } };

    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'revision':'2024-10-15' },
        body: JSON.stringify(iscrizione)
      }).then(function(r){ (r.status >= 200 && r.status < 300) ? ok() : ko(); })
        .catch(function(){ ko(); });
      setTimeout(ko, 12000);   
    } catch (e) { ko(); }

    
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'revision':'2024-10-15' },
        body: JSON.stringify({ data: { type:'event', attributes: {
          properties: props,
          metric:  { data: { type:'metric',  attributes: { name: 'Waitlist Request' } } },
          profile: { data: { type:'profile', attributes: { email: mail, first_name: nome, properties: props } } }
        } } })
      }).catch(function(){});
    } catch (e) {}
  }

  if (wroot){
    wroot.addEventListener('click', function(e){
      var t = e.target;
      if (!t || !t.closest) return;
      var p = t.closest('[data-sp-wait-paese]');
      if (p){   
        document.getElementById('sp-wait-country').value = p.getAttribute('data-sp-wait-paese');
        segnaWait(false);
        misura('sp_wait_switched', { finestra: 2, a: p.getAttribute('data-sp-wait-paese'), paese: waitIso, lingua: waitLang });
        return;
      }
      if (t.closest('#sp-wait-apri')){ e.preventDefault(); apriModulo(); return; }
      if (t.closest('[data-sp-wait-chiudi]')){ e.preventDefault(); chiudiWait(!document.getElementById('sp-wait-grazie').hidden); return; }
      if (t.closest('#sp-wait-ok')){ e.preventDefault(); iscriviWait(); }
    });
    
    wroot.addEventListener('keydown', function(e){
      if ((e.key === 'Enter' || e.keyCode === 13) && e.target && e.target.classList.contains('sp-wait__input')){
        e.preventDefault(); iscriviWait();
      }
    });
  }
  document.addEventListener('keydown', function(e){
    if (wroot && !wroot.hidden && (e.key === 'Escape' || e.key === 'Esc')) chiudiWait(!document.getElementById('sp-wait-grazie').hidden);
  });

  
  var finta = prova();
  if (window.Shopify && window.Shopify.designMode) return;   
  if (!finta && giaDeciso() && waitDeciso()) return;
  if (!finta && navigator.webdriver) return;                  

  function parti(){
    if (finta === 'DEBUG'){ diagnosi(); return; }
    if (finta){                                              
      if (NOSTRI.indexOf(finta) !== -1) return conLingua(lingua(finta), function(){ mostra(finta); });
      var tp = tipoWait(finta);
      if (!tp) return;                                       
      return conLingua(lingua(finta), function(){ mostraWait(finta, '', tp); });
    }
    aspettaConsenso(function(){
      rileva(function(rilevato, nomeShopify){
        if (!rilevato) return;
        if (NOSTRI.indexOf(rilevato) === -1){           
          var tipo = tipoWait(rilevato);
          if (!tipo || waitDeciso()) return;
          interesseWait(function(){
            conLingua(lingua(rilevato), function(){ mostraWait(rilevato, nomeShopify, tipo); });
          });
          return;
        }
        if (rilevato === paeseOra) return;              
        if (giaDeciso()) return;
        interesseLand(function(){
          conLingua(lingua(rilevato), function(){ mostra(rilevato); });
        });
      });
    });
  }
  if (document.readyState === 'complete') parti();
  else window.addEventListener('load', parti);
})();
